import { createTheme } from "@mui/material";
import "../Styles/App.css"

const theme = createTheme({
    typography : {
        fontFamily : "BurbankBigCondensed"
    }
});

export default theme;